export enum SurgicalQuestionId {
  SurgicalOperations = 'surgical_operations',
  Hazards = 'hazards',
  InvasiveDiagnostics = 'invasive_diagnostics'
}
